'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('AccessReviewAuthUserController', ['$scope', '$state', 'authLogin', 'accessReview', function ($scope, $state, authLogin, accessReview) {

    $scope.accessReview = accessReview;

    if ($state.is('accessReview.authUser')) {
        $state.transitionTo('accessReview.authUser.systemToReview',
                            { authLogin: authLogin },
                            { reload: true, inherit: false });

        return;
    }
}]);
